<template>
  <div>
    <div class="card p-3">
      <div class="row">
        <div class="col-6">
          <b>LAPORAN</b>
        </div>
        <div class="col-6">
          <div class="float-end">
            <button class="btn btn-sm mx-1 px-4" @click="downloadLaporan()">
              <i class="fa fa-file-excel-o text-success"></i> &nbsp; .xls
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                NO. REGISTRASI
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                PELANGGAN
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                ID STASIUN
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                STASIUN
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                TGL. UPLOAD IP
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                TGL. REGISTRASI
              </th>
              <th class="text-center text-secondary text-xxs font-weight-bolder opacity-7">
                TGL. EMAIL
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in props.dataTable" :key="index">
              <td class="text-center align-middle text-sm">
                <small>{{ data.noregistrasi }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.name }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.station }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>{{ data.idstasiunbumi }}</small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>
                  {{
                    `${nol(data.tglUpload[2])} - ${nol(data.tglUpload[1])} - ${nol(data.tglUpload[0])}`
                  }}
                </small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>
                  {{
                    `${nol(data.registrationdate[2])} - ${nol(data.registrationdate[1])} - ${nol(data.registrationdate[0])}`
                  }}
                </small>
              </td>
              <td class="text-center align-middle text-sm">
                <small>
                  {{
                    `${nol(data.tglEmail[2])} - ${nol(data.tglEmail[1])} - ${nol(data.tglEmail[0])}`
                  }}
                </small>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row">
          <div class="col-6">
            <h6>
              Showing
              {{ firstIndex }}
              to
              {{ lastIndex }}
              from {{ props.dataLength }} entries
            </h6>
          </div>

          <div class="col-6">
            <div class="float-end">
              <slot name="button"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup>
import { computed } from "vue";

const emit = defineEmits(['downloadLaporan'])
const props = defineProps({
  dataTable: Array,
  dataLength: Number,
  pageLength: Number,
  currentPage: Number,
  offset: Number,
  size: Number,
});

const downloadLaporan = async () => {
  emit('downloadLaporan');
}

const firstIndex = computed(() => {
  if (props.dataLength > 0) {
    return props.offset + 1;
  } else {
    return 0;
  }
});

const lastIndex = computed(() => {
  if (props.offset + props.size <= props.dataLength) {
    return props.offset + 10;
  } else {
    return props.dataLength;
  }
});

const nol = (x) => {
  const y = x > 9 ? (x > 99 ? x : "" + x) : "0" + x;
  return y;
};
</script>